<template>
    <div>
        <el-form ref="detailForm" :model="detailForm" label-width="120px">

            <el-form-item label="所在目录:">
                <span>{{ detailForm.parent_name }}</span>
            </el-form-item>

            <el-form-item label="应用名称:">
                <span>{{ detailForm.name }}</span>
            </el-form-item>

            <el-form-item label="应用类型:">
                <span>{{detailForm.apptype }}</span>
            </el-form-item>
            <el-form-item label="调用的应用:">
                <span v-for="item in detailForm.invokedApp">&nbsp;&nbsp;&nbsp;{{item}}&nbsp;&nbsp;&nbsp;</span>
            </el-form-item>

            <el-form-item label="应用图标:">
                <img :src='detailForm.img_url' style='width: 20px; height: 20px;'/>
            </el-form-item>

            <el-form-item label="Git 地址:">
                <span>{{ detailForm.git_path }}</span>
            </el-form-item>

            <el-form-item label="环境:">
                <el-button
                    v-for="(item, index) in detailForm.params"
                    :key="item.name"
                    :type='item.name === isSelect ? "primary": "" '
                    @click="selectType(index)">
                    {{item.title}}
                </el-button>
            </el-form-item>

            <el-form-item label="参数:">

                <el-table :data="tableData" border stripe>

                    <el-table-column label="参数名" prop="cname"></el-table-column>

                    <el-table-column label="参数值">
                        <template slot-scope="{ row }">
                            <a-fold :valueStr='row.value'></a-fold>
                        </template>
                    </el-table-column>

                </el-table>

            </el-form-item>

            <el-form-item label="负责人:">
                <span>{{ detailForm.superviser }}</span>
            </el-form-item>

            <el-form-item label="项目经理:">
                <span>{{ detailForm.projectusers }}</span>
            </el-form-item>

            <el-form-item label="产品经理:">
                <span>{{ detailForm.pmuser }}</span>
            </el-form-item>

            <el-form-item label="开发人员:">
                <span>{{ detailForm.devuser }}</span>
            </el-form-item>

            <el-form-item label="测试人员:">
                <span>{{ detailForm.qauser }}</span>
            </el-form-item>

            <el-form-item label="运维人员:">
                <span>{{ detailForm.maintainusers }}</span>
            </el-form-item>

            <el-form-item label="邮件组:">
                <span>{{ detailForm.mail }}</span>
            </el-form-item>

            <el-form-item label="备注:">
                <span>{{ detailForm.comment }}</span>
            </el-form-item>

            <el-form-item>
                <router-link :to="{ path: '/appcenterUseAdd',
                                    query: { type:'edit',
                                            appnodeId: parentId,
                                            callback: getDetail,
                                            count: {},
                                            parentType: 'edit'
                                        }}" v-w-role="'ITSM-0102'">
                    <el-button type="primary" @click="isEdited">编辑</el-button>
                </router-link>

                <el-button type="danger" @click="handleDel(detailForm.id)" v-w-role="'ITSM-0104'" style="margin-left: 10px">删除</el-button>
            </el-form-item>

        </el-form>
    </div>
</template>

<script>
    import services from '../../cicd.services'

    import AFold from '../../../common/aFold'
    export default {
        components: {
            AFold
        },

        computed: {
            dictionary() {
                return this.$store.state.dictionary2
            },
            type_list() {
                return this.dictionary.app_type
            },
            env() {
                return this.dictionary.env
            },
            isSelect() {
                let detail = this.detailForm
                return detail && detail.params[this.index] ? detail.params[this.index].name : []
            },
            tableData() {
                let detail = this.detailForm
                return detail.params ? detail.params[this.index] ? detail.params[this.index].content : [] : []
            },

            parentId() {
                return this.$route.query.id
            }
        },

        watch: {
            parentId(newVal) {
                this.getDetail()
            }
        },

        data() {
            return {
                detailForm: {},
                index: 0,
                appList:[],
                isEdit:false,
            }
        },
        mounted() {
            // console.log(this.$route.query.callback);
            // console.log(this.dictionary,'dic2');
            this.getDetail();
            this.getAppList()
        },

        methods: {
            getAppList(){
                services.appList().then(res=>{
                    this.appList=res.app_list
                })
            },

            // 改变环境
            selectType(index) {
                this.index = index
            },

            isEdited(){
                this.isEdit=true
            },
            // 获取详情
            getDetail() {
                services.nodeInfo( { appId: this.parentId } )
                    .then(res => {
                        // console.log('hahaha');
                        // console.log(this.dictionary,'dic2');
                        // console.log(this.type_list);
                        this.detailForm = {
                            ...res,
                            apptype:this.tableVal(res.apptype,this.type_list),
                            invokedApp:res.invoked_app.length!==0?res.invoked_app.map(item=>item.name):[],
                            projectusers: res.projectusers.map(item => item.name).join(","),
                            superviser: res.superviser.map(item => item.name).join(","),
                            devuser: res.devuser.map(item => item.name).join(","),
                            pmuser: res.pmuser.map(item => item.name).join(","),
                            maintainusers: res.maintainusers.map(item => item.name).join(","),
                            qauser: res.qauser.map(item => item.name).join(","),
                            mail: res.mail.map(item => item.mail).join(","),
                            params: res.params.map(item => ({
                                title: this.getNameByDefault(item.envId, this.env),
                                name: `${item.envId}`,
                                content: item.param
                            }))
                        }
                        if (this.isEdit){
                            this.$route.query.callback()
                            this.isEdit=false
                        }
                    })
                    .catch(err => this.$message.error(err.message))
            },
            // 删除按钮
            handleDel(count) {
                this.$confirm('确定要删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => services.deleteMenu(count))
                    .then(() => {
                        this.$message.success('删除成功')
                        this.$route.query.callback()
                        this.$router.push({
                            path: '/appcenterTree'
                        })
                    })
                    .catch((err) => {err ? this.$message.error(err.message): this.$message.info('已取消删除')})
            },
            // 根据数据字典取值
            tableVal(value, arr) {
                if(!arr) return '无'
                if(arr && arr.length == 0) return "无"
                let res = arr.filter(item => item.default == value)
                let str = ""
                if(!res.length) {
                    str =  "无"
                }else{
                    str = res[0].cname
                }
                return str
            },

        }
    }
</script>

<style>

</style>
